import React from "react";

import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { systemStatusOptions } from "utils/options/systemStatusOptions";

export default function EndcustomerFormSystem({
  handleInputChange,
  FORM_MODE,
  endcustomer,
}) {
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            name="ParseStatus"
            disabled
            label="Kontrollstatus"
            value={endcustomer.ParseStatus}
            size="small"
            color="primary"
            fullWidth
            margin="dense"
            type="text"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            name="ParseMessage"
            disabled
            label="Kontrollmeddelande"
            value={endcustomer.ParseMessage}
            size="small"
            color="primary"
            fullWidth
            margin="dense"
            type="text"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <FormControl margin="dense" fullWidth sx={{ textAlign: "left" }}>
            <InputLabel>System</InputLabel>
            <Select
              name="SystemStatus"
              disabled={FORM_MODE === "LOCKED" ? true : false}
              value={endcustomer.SystemStatus}
              onChange={(e) =>
                handleInputChange("SystemStatus", e.target.value)
              }
              label="Status"
              size="small"
            >
              {systemStatusOptions.map((option) => (
                <MenuItem key={option.Value} value={option.Value}>
                  {option.Name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            name="Skapad"
            label="Skapad"
            value={endcustomer.CreateTime}
            size="small"
            color="primary"
            fullWidth
            margin="dense"
            disabled
          />
        </Grid>
      </Grid>
    </>
  );
}

/*
    ExternalCustomerNr: endcustomer.ExternalCustomerNr,
    ID: endcustomer.ID,
*/
